import React from "react";
//Limitless imports
import { useExpertProfileContext, useAuthenticationContext } from "../../../expert";
import { POLICY_APP_INFO } from "../../utils/CommonPolicyConstants";
import Idle from "../idle/Idle";
const ActivityMonitor = () => {
  const {
    profile,
    canUserAccess
  } = useExpertProfileContext();
  const {
    isAuthenticated,
    signOut
  } = useAuthenticationContext();
  const timeout = React.useMemo(() => {
    let timeout = parseInt(process.env.REACT_APP_IDLE_TIME_EXPERT);
    const hasManagerRole = canUserAccess(POLICY_APP_INFO);
    if (hasManagerRole) {
      timeout = parseInt(process.env.REACT_APP_IDLE_TIME_MANAGER);
    }
    return timeout;
  }, [profile]);
  const handleIdleStateChange = ({
    idle
  }) => {
    if (isAuthenticated && idle) {
      signOut("You have been signed out due to inactivity");
    }
  };
  return /*#__PURE__*/React.createElement(Idle, {
    onChange: handleIdleStateChange,
    timeout: timeout
  });
};
export default ActivityMonitor;